import { color } from "highcharts";
import React, { useEffect } from "react";

function AppStatusDot({ progression_id, hasChild }) {
  const style = {
    width: "12px",
    maxWidth: "12px",
    height: "12px",
    maxHeight: "12px",
    borderRadius: "50%",
    flex: "1 0 auto",
    display: "block",
  };
  const getProgressionStatus = () => {
    if (progression_id < 5) {
      return { name: "Working Lead", color: "#b6d7a8" };
    }
    if (progression_id > 4 && progression_id < 7) {
      return { name: "App in Progress", color: "#a2c4c9" };
    }
    if (progression_id == 7) {
      return { name: "Sent for Signature", color: "#a4c2f4" };
    }
    if (progression_id == 8) {
      return { name: "Signed", color: "#b4a7d6" };
    }
    if (progression_id == 9) {
      return { name: "Pending Docs", color: "#ffe599" };
    }
    if (progression_id == 10 || (progression_id > 15 && progression_id < 19)) {
      return { name: "Underwriting", color: "#ffff00" };
    }
    if (progression_id > 10 && progression_id < 16) {
      return { name: "Unworkable", color: "#ff6d01" };
    }
    if (progression_id > 18 && progression_id < 25) {
      return { name: "Approved", color: "#34a853" };
    }
    if (progression_id > 24 && progression_id < 27) {
      return { name: "Declined", color: "#ea4335" };
    }
    if (progression_id == 27) {
      return { name: "Additional Signature Requested", color: "#810173" };
    }
    return { color: "orange", name: "Awaiting Preapptest" };
  };

  useEffect(() => {
    let status = getProgressionStatus();
  }, []);

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
      <span
        style={{ ...style, backgroundColor: getProgressionStatus()?.color }}
      ></span>
      {!hasChild && <span>{getProgressionStatus()?.name}</span>}
    </span>
  );
}

export default AppStatusDot;
